import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { FilterByPipe } from '../../pipe/filter-by.pipe';

@Component({
  selector: 'app-single-select',
  templateUrl: './single-select.component.html',
  styleUrls: ['./single-select.component.css']
})
export class SingleSelectComponent implements OnInit {

  // constructor() { }

  // ngOnInit(): void {
  // }
  SearchItem: string = '';
  searchD: string = '';
  filteredArr: any = [];
  selectedItemName: string = '';
  selectedItemChannel: string = '';
  searchText: string = '';
  displayList: boolean = false;
  selectedOption: any = null;
  selectedItemId: string = '';
  sector = {} as any;
  _dataArr: any = null;
  unchangedArr: any = null;
  @Input() uid: string = '';
  @Input() label: string = '';
  @Input() isDisabled: boolean = false;
  @Input() loader: boolean = false;
  @Input() SearchItem2: string = '';
  @Input() SearchItem1: string = '';
  @Input() channel: string = '';
  @Input() isLoading: boolean = false;
  @Input() placeholder: string = 'Select';
  @Input() searchShow: boolean = false;
  @Input() isListing: boolean = false;
  @Input() resetSearch: boolean = false;
  @Input() isSelectionChanged :boolean = false;
  @Input() isRequestListing : boolean = false;
  public objectX: any;
  public focusedItemIndex: any = null;
   /**
   * variable to track keypress event inside and outsid of component
   */
    public insideKeyPress = false;
  @Output() selectedEvent = new EventEmitter<string | null>();
  @Output() selectedDisplayValue = new EventEmitter<string>();
  @Output() selectedObject = new EventEmitter<any>();
  @Output() searchEmitter = new EventEmitter<any>();
  @ViewChild('searchInput') searchInput!: ElementRef;
  @ViewChild('listitem') listitem!: ElementRef;
  @ViewChild('searchBox') searchBox!: ElementRef<HTMLInputElement>
  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    if (!this._elementRef.nativeElement.contains(event.target)) {
      this.clickedOutside({});
    }
  }
  @ViewChildren('listitem')
  public availableOptions?: QueryList<ElementRef>;
  @HostListener('keydown', ['$event'])
  clickarrowx(event: any) {
    // ArrowDown
    if (event.code === 'ArrowDown' || event.key === 'ArrowDown') {
      event.preventDefault();
      (document.activeElement?.nextSibling as HTMLElement)?.focus();
    }

    // ArrowUp
    if (event.code === 'ArrowUp' || event.key === 'ArrowUp') {
      event.preventDefault();
      (document.activeElement?.previousSibling as HTMLElement)?.focus();
    }

    //Close on escape
    if (event.code === 'Escape' || event.key === 'Escape') {
      this.clickedOutside({});
    }
    if (event.code === 'Backspace' && this.searchText == '') {
      this.filteredArr = [];
      this._dataArr = this.unchangedArr;
      this.filteredArr = this.unchangedArr;
    }
    // Select on space
    if (event.code == 'Enter' || event.key == 'Enter') {
      if (this.displayList) {
        this.objectX = this._dataArr.find(
          (el: any) => el[`${this.label}`] == event.target.innerText
        );
        this.selectItem(this.objectX);
      }
      event.preventDefault();
    }
  }
  /**
   * Event handler for key up and down event and enter press for selecting element
   */
   @HostListener('keydown', ['$event'])
   public handleKeyboardEvent($event: KeyboardEvent | any) {
     this.insideKeyPress = true;
     /* istanbul ignore else */
     if ($event.keyCode === 27 ) {
       this.displayList = false;
       this.insideKeyPress = false;
       return;
     }
     const avaOpts = this.availableOptions?.toArray() || [];
     /* istanbul ignore else */
     
     if ($event.keyCode !== 9 && avaOpts.length === 0 && !this.displayList) {
       this.displayList = true;
       if(this.searchShow){
        setTimeout(() => {
          this.searchBox?.nativeElement.focus();
        }, 200);
      }
     }
     // Arrow Down
     /* istanbul ignore else */
     if ($event.keyCode === 40 && avaOpts.length > 0) {
       this.onArrowKeyDown();
       /* istanbul ignore else */
       if (this.focusedItemIndex >= avaOpts.length) {
         this.focusedItemIndex = 0;
       }
       avaOpts[this.focusedItemIndex].nativeElement.focus();
       $event.preventDefault();
     }
     // Arrow Up
     /* istanbul ignore else */
     if ($event.keyCode === 38 && avaOpts.length) {
       this.onArrowKeyUp();
       /* istanbul ignore else */
       if (this.focusedItemIndex >= avaOpts.length) {
         this.focusedItemIndex = avaOpts.length - 1;
       }
       avaOpts[this.focusedItemIndex].nativeElement.focus();
       $event.preventDefault();
     }
  // Enter
    /* istanbul ignore else */
    if ($event.keyCode === 13 && this.focusedItemIndex !== null) {
      const filteredItems = new FilterByPipe().transform(
        this.filteredArr,
        (this.searchText as string),
       // this.config.searchOnKey
      );
      this.selectItem(filteredItems[this.focusedItemIndex])
      return false;
    }
     return true;
   }
    /**
   * Event handler for arrow key down event thats focuses on a item
   */
  private onArrowKeyDown() {
    /* istanbul ignore else */
    if (this.focusedItemIndex === this.filteredArr.length - 1) {
      this.focusedItemIndex = 0;
      return;
    }
    /* istanbul ignore else */
    if (this.onArrowKey()) {
      this.focusedItemIndex++;
    }
  }
  private onArrowKey() {
    /* istanbul ignore else */
    if (this.focusedItemIndex === null) {
      this.focusedItemIndex = 0;
      return false;
    }
    return true;
  }
  private onArrowKeyUp() {
    /* istanbul ignore else */
    if (this.focusedItemIndex === 0) {
      this.focusedItemIndex = this.filteredArr.length - 1;
      return;
    }
    /* istanbul ignore else */
    if (this.onArrowKey()) {
      this.focusedItemIndex--;
    }
  }
  @Input() set dataArr(value: any[]) {
    this._dataArr = value;
    this.unchangedArr = value;
    if (this._dataArr && this._dataArr.length) {
      this.filteredArr = [];
      this._dataArr.forEach((item: any) => {
        if (Number.isInteger(item) || item.length) {
          const obj: any = {};
          obj[this.uid] = item;
          obj[this.label] = item;
          this.filteredArr.push(obj);
        } else {
          this.filteredArr = value;
        }
      });
    } else {
      this.filteredArr = value;
    }
  }

  @Input() set selectedData(value: any) {
    if (value || (value === 0 && value !== '')) {
      this.selectedOption = value;
      this.setSelectedItem();
    } else {
      this.selectedItemId = '';
      this.selectedItemName = '';
      this.selectedOption = null;
    }
  }

  constructor(public _elementRef: ElementRef) {}

  // To show and hide drop down
  showDropdown() {
    if (!this.isDisabled) {
      this.displayList = !this.displayList;
      if (this.resetSearch && this.searchText) {
        this.searchText = '';
        this.searchEmitter.emit(this.searchText);
      }
    }
    setTimeout(() => {
      this.searchBox?.nativeElement.focus();
    }, );
  }

  ngOnChanges(changes: SimpleChanges) {
   
    if (this._dataArr && this._dataArr.length) {
      if (this.selectedOption) {
        this.setSelectedItem();
      } else {
        this.selectedItemId = '';
        this.selectedItemName = '';
      }

      let tempArray: any = [];
      tempArray = this.filteredArr.filter(
        (el: any) => el[this.label] && el[this.label].toString().trim() !== ''
      );
      this._dataArr = tempArray;
      this.filteredArr = tempArray;
    } else {
      this.selectedItemId = '';
      this.selectedItemName = '';
    }
  }

  ngOnInit(): void {
    this.SearchItem = this.label;
    this.searchText = '';
    //this.setFocus();
  }

  private setSelectedItem() {
    if (typeof this.selectedOption !== 'object') {
      const obj: any = {};
      obj[this.uid] = this.selectedOption!=null ? this.selectedOption : null;
      obj[this.label] = this.selectedOption ? this.selectedOption : null;
      this.selectedOption = obj;
    }
    if (this.selectedOption && this._dataArr) {
      let isAvailable = false;
      let selectedObject: any;
      this._dataArr.forEach((item: any) => {
        let retValue = this.selectTypChk(item, isAvailable, selectedObject);
        isAvailable = retValue[0];
        selectedObject = retValue[1];
      });
      if (isAvailable) {
        if (typeof this.selectedOption === 'string') {
          this.selectedItemId = this.selectedOption;
          this.selectedItemName = this.selectedOption;
        } else {
          this.selectedItemId = selectedObject[this.uid];
          this.selectedItemName = selectedObject[this.label];
          this.selectedItemChannel = selectedObject[this.channel];
        }
      }
    }
  }

  clickedOutside(event: any) {
    this.displayList = false;
  }

  onSearch() {
    
    this.filteredArr = this.unchangedArr;
    this._dataArr = this.unchangedArr;
    if (this.searchText && this.searchText !== '') {
      if (this._dataArr && this._dataArr.length) {
        this.filteredArr = this._dataArr.filter((item: any) => {
          const searchValue = this.searchText.toLowerCase();
          if (searchValue.trim() !== '') {
            return JSON.stringify(item[this.label])
              .toLowerCase()
              .includes(searchValue.trim());
          }
          return false;
        });
      } else {
        this.filteredArr = [];
      }
    } else {
      this.filteredArr = this.unchangedArr;
    }
  }

  selectItem = (item: any) => {
    this.displayList = false;
    this.selectedItemId = item[this.uid];
    this.selectedItemName = item[this.label];
    this.selectedItemChannel = item[this.channel];
    this.selectedEvent.emit(item[this.uid]);
    this.selectedDisplayValue.emit(item[this.label]);
    this.selectedObject.emit(item);
  };

  onEnter(key: string, item: any) {
    if (key === 'Enter') {
      this.selectItem(item);
    }
  }

  checkLimit(event: any) {
    if (event.code === 'Tab') {
      event.preventDefault();
      return;
    }

    if (
      this.searchText.length < 1 ||
      (this.searchText.length >= 2 && this.searchText.length < 20)
    ) {
      this.searchEmitter.emit(this.searchText);
    }
  }
  clearSelectedItem() {
    this.selectedItemName = '';
    this.selectedObject.emit(null);
    this.selectedEvent.emit(null);
    this.searchText='';
    this.filteredArr = this.unchangedArr;
  }
  selectTypChk(item: any, isAvailable: boolean, selectedObject: any) {
    if (typeof this.selectedOption !== 'object') {
      if (item[this.uid] === this.selectedOption) {
        isAvailable = true;
        selectedObject = item;
      }
    } else {
      if (item[this.uid] === this.selectedOption[this.uid]) {
        isAvailable = true;
        selectedObject = item;
      }
    }
    return [isAvailable, selectedObject];
  }
}
